/**
 * "Level 5 · Mushroom Glade" — the player's current level and its theme,
 * with a tiny swatch of that theme's sky.
 */
import type { Locale, ThemePack } from '@dropstack/core';
import { useT } from '../i18n/index.ts';
import './ui.css';

export interface LevelChipProps {
  level: number;
  theme: ThemePack;
  locale: Locale;
  size?: 'normal' | 'compact';
}

export function LevelChip({ level, theme, locale, size = 'normal' }: LevelChipProps) {
  const t = useT();
  return (
    <span className={`ui-level-chip ui-level-chip--${size}`}>
      <span
        className="ui-level-chip__swatch"
        aria-hidden="true"
        style={{ background: `linear-gradient(${theme.palette.skyTop}, ${theme.palette.skyBottom})` }}
      />
      <span className="ui-level-chip__level">{t('common.levelN', { level })}</span>
      {size === 'normal' && (
        <>
          <span className="ui-level-chip__dot" aria-hidden="true">
            ·
          </span>
          <span className="ui-level-chip__theme">{theme.name[locale]}</span>
        </>
      )}
    </span>
  );
}
